export default "__VITE_ASSET__Cl_foTw8__"